import { __assign, __rest } from "tslib";
import React from 'react';
import VeltTranscriptionContentItemTextWireframe from './VeltTranscriptionContentItemTextWireframe/VeltTranscriptionContentItemTextWireframe';
import VeltTranscriptionContentItemTimeWireframe from './VeltTranscriptionContentItemTimeWireframe/VeltTranscriptionContentItemTimeWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltTranscriptionContentItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionContentItemWireframe.Time = VeltTranscriptionContentItemTimeWireframe;
VeltTranscriptionContentItemWireframe.Text = VeltTranscriptionContentItemTextWireframe;
export default VeltTranscriptionContentItemWireframe;
